"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    toolbarClassNames: function() {
        return toolbarClassNames;
    },
    useToolbarStyles_unstable: function() {
        return useToolbarStyles_unstable;
    }
});
const _react = require("@griffel/react");
const toolbarClassNames = {
    root: 'fui-Toolbar'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        mc9l5x: "f22iagw",
        Bt984gj: "f122n59",
        z8tnut: "f10ra9hq",
        z189sj: [
            "f19lj068",
            "f177v4lu"
        ],
        Byoj8tv: "f1y2xyjm",
        uwmqm3: [
            "f177v4lu",
            "f19lj068"
        ]
    },
    vertical: {
        Beiy3e4: "f1vx9l62",
        a9b677: "f1acs6jw"
    },
    small: {
        z8tnut: "f1nbblvp",
        z189sj: [
            "f8wuabp",
            "fycuoez"
        ],
        Byoj8tv: "f1ov4xf1",
        uwmqm3: [
            "fycuoez",
            "f8wuabp"
        ]
    },
    medium: {
        z8tnut: "f10ra9hq",
        z189sj: [
            "f19lj068",
            "f177v4lu"
        ],
        Byoj8tv: "f1y2xyjm",
        uwmqm3: [
            "f177v4lu",
            "f19lj068"
        ]
    },
    large: {
        z8tnut: "f10ra9hq",
        z189sj: [
            "fat0sn4",
            "fekwl8i"
        ],
        Byoj8tv: "f1y2xyjm",
        uwmqm3: [
            "fekwl8i",
            "fat0sn4"
        ]
    }
}, {
    d: [
        ".f22iagw{display:flex;}",
        ".f122n59{align-items:center;}",
        ".f10ra9hq{padding-top:4px;}",
        ".f19lj068{padding-right:8px;}",
        ".f177v4lu{padding-left:8px;}",
        ".f1y2xyjm{padding-bottom:4px;}",
        ".f1vx9l62{flex-direction:column;}",
        ".f1acs6jw{width:fit-content;}",
        ".f1nbblvp{padding-top:0px;}",
        ".f8wuabp{padding-right:4px;}",
        ".fycuoez{padding-left:4px;}",
        ".f1ov4xf1{padding-bottom:0px;}",
        ".fat0sn4{padding-right:20px;}",
        ".fekwl8i{padding-left:20px;}"
    ]
});
const useToolbarStyles_unstable = (state)=>{
    const styles = useStyles();
    const { vertical, size } = state;
    state.root.className = (0, _react.mergeClasses)(toolbarClassNames.root, styles.root, vertical && styles.vertical, size === 'small' && !vertical && styles.small, size === 'medium' && !vertical && styles.medium, size === 'large' && !vertical && styles.large, state.root.className);
    return state;
}; //# sourceMappingURL=useToolbarStyles.styles.js.map
